import posthog from 'posthog-js'
import type { App, Plugin } from 'vue'
import type { Router } from 'vue-router'

export const PostHogPlugin: Plugin = {
  install(app: App, options: { router: Router }) {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_POSTHOG_HOST,
      capture_pageview: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
        maskTextFn: (text) => text.replace(/\d/g, '*'),
        maskInputFn: (text) => text.replace(/\d/g, '*'),
      },
    })

    app.config.globalProperties.$posthog = posthog

    options.router.afterEach((to) => {
      posthog.capture('$pageview', { $current_url: to.fullPath })
    })
  },
}
